<template>
    <div class="border rounded-xl w-full p-[16px] flex justify-between items-center font-light">
        <div>
            <h2>{{ permission.name }}</h2>
            <p class="font-extralight mt-[2px] text-[12px]">{{ permission.description }}</p>
        </div>

        <button :disabled="load" @click="activeOrDisable(containPerm(userPerm,permission.name))" :class="['h-[35px] font-light px-4 border rounded-xl flex items-center justify-center',{'bg-[#5357eb] text-white border-[#5357eb]':containPerm(userPerm,permission.name)}]">
            <Loader2 v-if="load" class="animate-spin mx-auto"/>
            <span v-if="!load">{{ containPerm(userPerm,permission.name) ? "Désactiver" : "Activer"}}</span>
        </button>
    </div>
</template>
<script>
import API from '@/service/API';
import Swal from 'sweetalert2';
import { Loader2 } from 'lucide-vue-next';
export default {
    name: "PermissionBtn",
    components:{Loader2},
    props: ["userId","permission","userPerm"],
    data(){
        return {
            load: false
        }
    },
    methods:{
        activeOrDisable(value){
            this.load = true;
            API.post(value ? "permissions/revoke" : "permissions/assign",{"user_id": this.userId,"permission_id": this.permission.id})
            .then((res)=>{
                if(!res.data.status) throw Error(res.data.message)
                this.$emit('child-action');
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=> this.load = false)
        },
        containPerm(tab,libelle){
            let match = false;
            for (const element of tab) {
                if(element.name == libelle){
                    match = true;
                    break;
                }
            }
            return match;
        }
    }
}
</script>